// Helper function for Dutch number formatting
function formatDutchPrice(cents) {
  const euros = (cents / 100).toFixed(2);
  const parts = euros.split('.');
  // Add thousand separator (.)
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  // Join with comma as decimal separator
  return parts.join(',');
}

document.addEventListener('bundler:total_cart_values', function (e) {
  const {
    total_amount_original = 0,
    total_amount_discounted = 0,
    discount_amount = 0,
    discounted_cart_object = null,
  } = e.detail;

  // DEBUG LOGS
  console.log('=== BUNDLER EVENT FIRED ===');
  console.log('total_amount_original:', total_amount_original);
  console.log('total_amount_discounted:', total_amount_discounted);
  console.log('discount_amount:', discount_amount);
  console.log('Cart items:', discounted_cart_object?.items);

  // VAT configuration
  const VAT_RATE = 0.21; // 21% VAT rate for Netherlands
  
  // Calculate subtotal excluding VAT
  const subtotalExcludingVat = total_amount_original;
  
  // Update subtotal display (now excluding VAT)
  const subtotalWithoutTaxElement = document.getElementById('cart-price_subtotal');
  const formattedSubtotalExVat = formatDutchPrice(subtotalExcludingVat);
  if (subtotalWithoutTaxElement) {
    subtotalWithoutTaxElement.textContent = `€${formattedSubtotalExVat}`;
    subtotalWithoutTaxElement.setAttribute('data-excl-price', subtotalExcludingVat);
  }

  const cartPriceTax = document.getElementById('cart-price_tax');

  // Calculate and track all discounts
  let totalDiscount = discount_amount;
  let compareAtDiscounts = 0;
  let automaticDiscounts = 0; // Track automatic (collection) discounts
  let promises = [];

  if (discounted_cart_object && discounted_cart_object.items) {
    discounted_cart_object.items.forEach((item, itemIndex) => {
      const itemElement = document.querySelector(`[data-cart-variant="${item.variant_id}"]`) ||
        document.querySelector(`[data-cart-variant="${item.id}"]`);
      
      // Check for automatic discounts on line items
      if (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) {
        item.line_level_discount_allocations.forEach((discount) => {
          automaticDiscounts += discount.amount;
          
          // Update display to show discount
          if (itemElement) {
            const originalPrice = item.original_line_price;
            const discountedPrice = item.final_line_price;
            
            const oldPriceElements = itemElement.querySelectorAll('[data-old-price]');
            oldPriceElements.forEach(oldPriceEl => {
              if (oldPriceEl) {
                oldPriceEl.textContent = `€${(originalPrice / 100).toFixed(2).replace('.', ',')}`;
                oldPriceEl.style.display = 'block';
              }
            });

            const newPriceElements = itemElement.querySelectorAll('[data-new-price]');
            newPriceElements.forEach(newPriceEl => {
              if (newPriceEl) {
                newPriceEl.textContent = `€${(discountedPrice / 100).toFixed(2).replace('.', ',')}`;
                newPriceEl.setAttribute('data-excl-price', discountedPrice);
              }
            });
            
            // Add discount badge
            const discountBadgeContainer = itemElement.querySelector('[data-discount-badge]');
            if (discountBadgeContainer && !discountBadgeContainer.querySelector('.discount-badge')) {
              const discountPercentage = Math.round((discount.amount / originalPrice) * 100);
              const badge = document.createElement('span');
              badge.className = 'discount-badge inline-block ml-2 bg-red-500 text-white font-bold px-2 py-1 rounded text-xs';
              badge.textContent = `-${discountPercentage}%`;
              discountBadgeContainer.appendChild(badge);
            }
          }
        });
      }
      
      // Fetch full product info to get compare_at_price
      const promise = fetch(`/products/${item.handle}.js`)
        .then((response) => response.json())
        .then((product) => {
          const variant = product.variants.find(v => v.id == item.variant_id) || 
                         product.variants.find(v => v.title == item.variant_title);
          
          if (!variant) return;
          
          // Only check compare_at_price if no automatic discount was applied
          if (!item.line_level_discount_allocations || item.line_level_discount_allocations.length === 0) {
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              const itemDiscount = (variant.compare_at_price - variant.price) * item.quantity;
              compareAtDiscounts += itemDiscount;
              
              // Update display: oude prijs alleen product (gelijk aan PDP), verzending apart in overzicht
              if (itemElement) {
                const oldPriceCents = variant.compare_at_price * item.quantity;
                const oldPriceElements = itemElement.querySelectorAll('[data-old-price]');
                oldPriceElements.forEach(oldPriceEl => {
                  if (oldPriceEl) {
                    oldPriceEl.textContent = `€${(oldPriceCents / 100).toFixed(2).replace('.', ',')}`;
                    oldPriceEl.style.display = 'block';
                  }
                });

                const newPriceElements = itemElement.querySelectorAll('[data-new-price]');
                newPriceElements.forEach(newPriceEl => {
                  if (newPriceEl) {
                    newPriceEl.textContent = `€${(item.line_price / 100).toFixed(2).replace('.', ',')}`;
                    newPriceEl.setAttribute('data-excl-price', item.line_price);
                  }
                });
              }
            } else if (itemElement) {
              // Hide old price if there's no discount
              const oldPriceElements = itemElement.querySelectorAll('[data-old-price]');
              oldPriceElements.forEach(oldPriceEl => {
                if (oldPriceEl) {
                  oldPriceEl.style.display = 'none';
                }
              });
            }
          }
        })
        .catch(error => {
          console.error(`Error fetching product data for ${item.handle}:`, error);
        });
      
      promises.push(promise);
    });
  }

  // Update all prices after all fetch requests complete
  Promise.all(promises).then(() => {
    // Combine all discount types
    const combinedDiscount = totalDiscount + compareAtDiscounts + automaticDiscounts;
    
    console.log('=== AFTER PROMISES ===');
    console.log('totalDiscount:', totalDiscount);
    console.log('compareAtDiscounts:', compareAtDiscounts);
    console.log('automaticDiscounts:', automaticDiscounts);
    console.log('combinedDiscount:', combinedDiscount);
    console.log('total_amount_discounted:', total_amount_discounted);

    // Update subtotal to show full price including compare_at_price (without any discounts)
    const subtotalWithComparePrices = total_amount_original + compareAtDiscounts;
    if (subtotalWithoutTaxElement) {
      subtotalWithoutTaxElement.textContent = `€${formatDutchPrice(subtotalWithComparePrices)}`;
      subtotalWithoutTaxElement.setAttribute('data-excl-price', subtotalWithComparePrices);
    }

    // Update total discount display
    const totalDiscountElement = document.getElementById('cart-price_discount');
    if (totalDiscountElement && combinedDiscount > 0) {
      const formattedDiscount = (combinedDiscount / 100).toFixed(2).replace('.', ',');
      totalDiscountElement.textContent = `€${formattedDiscount}`;
      totalDiscountElement.setAttribute('data-excl-price', combinedDiscount);
      
      // Show discount row
      document.querySelectorAll('[data-cart-discount]').forEach((el) => {
        el.classList.add('flex');
        el.classList.remove('hidden');
      });
    } else {
      // Hide discount row if no discounts
      document.querySelectorAll('[data-cart-discount]').forEach((el) => {
        el.classList.remove('flex');
        el.classList.add('hidden');
      });
    }

    // ============ NEW FIX: Update total price after discounts are calculated ============
    // total_amount_original is al de verkoopprijs (compare-at korting zit er al in),
    // dus alleen de echte kortingen eraf halen, anders gaat de compare-at korting er 2x af.
    const actualDiscountedTotal = total_amount_original - totalDiscount - automaticDiscounts;
    console.log('actualDiscountedTotal:', actualDiscountedTotal);

    const shippingThreshold = 15000;
    const shippingAmountEl = document.getElementById('cart-shipping_amount');
    const shippingCentsFromLiquid = shippingAmountEl ? parseInt(shippingAmountEl.getAttribute('data-shipping-cents'), 10) : NaN;
    const isSpoedverzending = !isNaN(shippingCentsFromLiquid) && shippingCentsFromLiquid > 661;
    const shippingCostInCents = (!isNaN(shippingCentsFromLiquid) && shippingCentsFromLiquid >= 0) ? shippingCentsFromLiquid : 661;

    let finalTotalWithShipping = actualDiscountedTotal;
    if (actualDiscountedTotal < shippingThreshold && !isSpoedverzending) {
      finalTotalWithShipping = actualDiscountedTotal + shippingCostInCents;
    }

    console.log('finalTotalWithShipping:', finalTotalWithShipping);

    const totalPriceElement = document.getElementById('cart-price_total');
    if (totalPriceElement) {
      totalPriceElement.textContent = `€${formatDutchPrice(finalTotalWithShipping)}`;
      totalPriceElement.setAttribute('data-excl-price', finalTotalWithShipping);
    }

    // Deze prijsupdate draait async ná de VAT-switcher en overschrijft de total met de
    // EXCL-prijs. Pas de incl/excl-weergave opnieuw toe zodat de total de switcher volgt.
    if (typeof window.reapplyVatPrices === 'function') {
      window.reapplyVatPrices();
    }
  });

  // Updated shipping threshold logic to match Dutch shipping rates
  const shippingThreshold = 15000; // 150 euros in cents (free shipping threshold)
  const shippingCostInCents = 661; // €5,95 in cents
  const progressBarElement = document.getElementById('shipping-progress-bar');
  const shippingMessageElement = document.getElementById('shipping-message');
  const shippingCostElement = document.getElementById('cart-shipping_amount');
  const shippingCosts = document.getElementById('shipping-costs');
  const shippingCostElementContainer = document.getElementById('cart-shipping_amount-container');

  // Calculate final total including shipping
  let finalTotalWithShipping = total_amount_discounted;
  
  if (progressBarElement) {
    const progressPercentage = Math.min((total_amount_discounted / shippingThreshold) * 100, 100);
    progressBarElement.style.width = `${progressPercentage}%`;
  }

  const shippingCentsFromLiquid = shippingCostElement ? parseInt(shippingCostElement.getAttribute('data-shipping-cents'), 10) : NaN;
  const isSpoedverzending = !isNaN(shippingCentsFromLiquid) && shippingCentsFromLiquid > 661;
  const effectiveShippingCents = (!isNaN(shippingCentsFromLiquid) && shippingCentsFromLiquid >= 0) ? shippingCentsFromLiquid : shippingCostInCents;

  if (total_amount_discounted < shippingThreshold) {
    finalTotalWithShipping = total_amount_discounted + (isSpoedverzending ? 0 : effectiveShippingCents);

    const amountLeft = ((shippingThreshold - total_amount_discounted) / 100).toFixed(2).replace('.', ',');
    shippingMessageElement.innerHTML = `Nog 
        <span class="font-bold" id="shipping-threshold-left">
        €${amountLeft}
        </span>
        voor <span class="font-bold text-success">gratis</span> verzending`;

    if (shippingCostElement) {
      shippingCostElementContainer.classList.remove('hidden');
      if (!isSpoedverzending) {
        shippingCostElement.textContent = '€6,61';
        shippingCostElement.setAttribute('data-excl-price', 661);
      }
      shippingCostElement.classList.remove('text-[#4BD528]');
      shippingCostElement.classList.add('text-black');

      const cartPriceTaxPrice = cartPriceTax.getAttribute('data-vat-price');
      let shippingVAT = isSpoedverzending ? 0 : ((effectiveShippingCents * 1.21) - effectiveShippingCents);
      let totalVAT = ((parseFloat(cartPriceTaxPrice) + shippingVAT) / 100).toFixed(2).replace('.', ',');
      cartPriceTax.textContent = `€${totalVAT}`;
    }

    if (shippingCosts) {
      shippingCosts.style.display = 'flex';
    }
  } else {
    shippingMessageElement.innerHTML = `Je hebt <span class="font-bold text-success">gratis</span> verzending`;
    if (shippingCostElement) {
      shippingCostElementContainer.classList.remove('hidden');
      shippingCostElement.textContent = 'Gratis';
      shippingCostElement.removeAttribute('data-excl-price');
      shippingCostElement.classList.add('text-[#4BD528]');
      shippingCostElement.classList.remove('text-black');
    }

    if (shippingCosts) {
      shippingCosts.style.display = 'none';
    }
  }

  // NOTE: Total price update happens in Promise.all above, not here anymore
});

// Rest of the code stays the same...
function increaseQuantity(event, id) {
  event.preventDefault();
  const input = document.querySelector(`#Quantity-Input-${id}`);
  if (input) {
    const currentValue = parseInt(input.value) || 0;
    const max = input.getAttribute('max');
    const step = parseInt(input.getAttribute('step')) || 1;
    const newValue = currentValue + step;
    
    if (!max || newValue <= parseInt(max)) {
      input.value = newValue;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      updateCartQuantity(id, newValue);
    }
  }
}

function decreaseQuantity(event, id) {
  event.preventDefault();
  const input = document.querySelector(`#Quantity-Input-${id}`);
  if (input) {
    const currentValue = parseInt(input.value) || 0;
    const min = parseInt(input.getAttribute('min')) || 0;
    const step = parseInt(input.getAttribute('step')) || 1;
    const newValue = currentValue - step;
    
    if (newValue >= min) {
      input.value = newValue;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      updateCartQuantity(id, newValue);
    }
  }
}

function updateCartQuantity(lineItem, quantity) {
  const formData = {
    'line': lineItem,
    'quantity': quantity
  };
  
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    location.reload();
  })
  .catch((error) => {
    console.error('Error updating cart:', error);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  const totalPriceElement = document.getElementById('cart-price_total');
  if (totalPriceElement && totalPriceElement.textContent) {
    const currentText = totalPriceElement.textContent.trim();
    const numericValue = currentText.replace(/[^0-9]/g, '');
    if (numericValue) {
      totalPriceElement.textContent = `€${formatDutchPrice(parseInt(numericValue))}`;
    }
  }

  const removeButtons = document.querySelectorAll('cart-remove-button a');
  removeButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const url = this.getAttribute('href');
      
      this.style.opacity = '0.5';
      this.style.pointerEvents = 'none';
      
      fetch(url, {
        method: 'GET',
      })
      .then(() => {
        location.reload();
      })
      .catch(error => {
        console.error('Error removing item:', error);
        this.style.opacity = '1';
        this.style.pointerEvents = 'auto';
      });
    });
  });

  const quantityInputs = document.querySelectorAll('.quantity__input');
  quantityInputs.forEach(input => {
    let timeout;
    input.addEventListener('change', function() {
      clearTimeout(timeout);
      const lineItem = this.getAttribute('data-index');
      const quantity = parseInt(this.value) || 0;
      
      timeout = setTimeout(() => {
        updateCartQuantity(lineItem, quantity);
      }, 500);
    });
  });
});